import React from 'react';
import './ComingSoon.css';
import { useEffect } from 'react';

const ComingSoon = () => {
    useEffect(() => {
        // Parse the query parameters
        const params = new URLSearchParams(window.location.search);
        if (params.has('stripeReturnType')) {
            const queryString = params.toString();

            // Your deep link base (could also be an App Link URL)
            const deepLinkBase = `totum://profile`;

            // Combine them
            const deepLink = `${deepLinkBase}?${queryString}`;

            // Attempt to open the app
            window.location.href = deepLink;
        }
        
    });

    return (
        <div className="container">
            <div className='row1'>
                <div className='copy-holder'>
                    <h1>Totum</h1>
                    <p className='description'>From aspiring artists, to upcoming athletes, to wannabe chefs - Totum connects you to the experts you know.</p>                    
                </div>
            </div>
            <div className='image-holder'>
                <img
                    className='app-preview'
                    alt='App preview'
                    src="./images/apple-iphone-15-pink-mockup/dashboard-3d-right.png"></img>
            </div>
            <div className='row2'>
                <p>Real connections.<br/>Real growth.</p>
                <p className="coming-soon">Coming in 2025</p>
            </div>
            
        </div>
    );
};

export default ComingSoon;
